import { render, staticRenderFns } from "./ScreenDetalleAreas.vue?vue&type=template&id=6d8774d8&scoped=true"
import script from "./ScreenDetalleAreas.vue?vue&type=script&lang=js"
export * from "./ScreenDetalleAreas.vue?vue&type=script&lang=js"
import style0 from "./ScreenDetalleAreas.vue?vue&type=style&index=0&id=6d8774d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8774d8",
  null
  
)

export default component.exports